<template>
  <nav id="sidebar" class="sidebar" :class="{ close: isOculto }">
    <header>
      <div class="logo">
        <span class="image">
          <Transition name="fade">
            <router-link :to="{ name: 'dashboard' }" class="ybrand">
              <img
                v-if="!isOculto"
                class="logo-text"
                src="@/assets/logo2.png"
                alt="logo-text"
              />
              <img
                v-if="isOculto"
                class="logo-icon"
                src="@/assets/logo-icon.png"
                alt="logo-icon"
              />
            </router-link>
          </Transition>
        </span>
      </div>
      <div class="profile">
        <div class="profile-details">
          <img
            @click="goToCompany()"
            :src="
              imageCompany
                ? imageCompany
                : require('@/assets/icons/user-default.png')
            "
            alt="profileImg"
            v-tooltip.right-end="tooltipProfile()"
          />
          <div class="name_company">
            <router-link
              v-show="isAuthenticated"
              class="name truncate"
              :to="{ name: 'perfil' }"
            >
              {{ tokenUser ? tokenUser.name : "" }}
            </router-link>
            <router-link class="company truncate" :to="{ name: 'empresas' }">
              {{ empresa.nombre }}
            </router-link>
          </div>
        </div>
      </div>
      <i class="material-icons toggle" v-on:click="toggleMenu()">
        chevron_right
      </i>
    </header>
    <div class="content-menu">
      <div class="menu-bar">
        <div class="menu">
          <ul class="menu-links">
            <div v-for="k in menu" :key="k.$index" :group="k.group">
              <div class="menu-label">
                <p class="title">{{ k.group }}</p>
              </div>
              <li class="nav-link" v-for="k1 in k.menus" :key="k1.$index">
                <router-link :to="{ name: k1.ruta }" class="a">
                  <i
                    class="material-icons icon"
                    v-tooltip.right-end="getTooltip(k1.title)"
                    >{{ k1.icon }}</i
                  >
                  <span class="text nav-text">{{ k1.title }}</span>
                </router-link>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <li class="">
        <router-link
          v-show="isAuthenticated"
          :to="{ name: 'logout' }"
          class="a"
        >
          <i class="material-icons icon">meeting_room</i>
          <span class="text nav-text">Salir</span>
        </router-link>
      </li>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";
import rutas from "@/routes";
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      imageCompany: null,
      menu: [],
    };
  },
  props: {
    isMovil: {
      type: Boolean,
    },
    isVisible: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState([
      "isAuthenticated",
      "empresa",
      "tokenUser",
      "windowheight",
      "isOculto",
    ]),
    styleObject() {
      let d = {};
      if (this.isMovil) {
        d = {};
      } else {
        d.position = "fixed";
        d.top = 0;
      }
      return d;
    },
    styleObject1() {
      let d = {};
      const w = this.windowheight - 190;
      d.height = `${w}px`;
      return d;
    },
  },
  watch: {
    tokenUser(oldv, newv) {
      this.constuyeMenu();
    },
    isMovil() {
      console.log(this.isMovil);
    },
    empresa() {
      this.getImgCompany(this.empresa._id);
    },
  },
  methods: {
    logout() {
      this.$router.push("landing");
      firebase
        .auth()
        .signOut()
        .then(function() {
          localStorage.removeItem("isLogged");
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goToCompany() {
      if (this.$route.path !== "/empresas")
        this.$router.push({ name: "empresas" });
    },
    constuyeMenu() {
      this.menu = [];
      const menu = {
        sections: [],
      };
      rutas.options.routes.forEach((k) => {
        if (this.tokenUser) {
          if (k.menu) {
            let control = false;
            k.menu.scope.forEach((k1) => {
              if (this.tokenUser[k1]) {
                control = true;
              }
            });
            if (control) {
              if (menu.sections.indexOf(k.menu.section) === -1) {
                menu.sections.push(k.menu.section);
                menu[k.menu.section] = {
                  group: k.menu.section,
                  menus: [],
                };
                if (k.meta.isPublic) {
                  menu[k.menu.section].menus.push({
                    title: k.menu.title,
                    ruta: k.name,
                    icon: k.menu.icon,
                  });
                }
                if (!k.meta.isPublic && this.isAuthenticated) {
                  menu[k.menu.section].menus.push({
                    title: k.menu.title,
                    ruta: k.name,
                    icon: k.menu.icon,
                  });
                }
              } else {
                if (k.meta.isPublic) {
                  menu[k.menu.section].menus.push({
                    title: k.menu.title,
                    ruta: k.name,
                    icon: k.menu.icon,
                  });
                }
                if (!k.meta.isPublic && this.isAuthenticated) {
                  menu[k.menu.section].menus.push({
                    title: k.menu.title,
                    ruta: k.name,
                    icon: k.menu.icon,
                  });
                }
              }
            }
          }
        }
      });
      menu.sections.forEach((k) => {
        if (menu[k].menus.length > 0) {
          this.menu.push(menu[k]);
        }
      });
    },
    toggleMenu() {
      this.$store.commit("ocultarSide");
    },
    getTooltip(content) {
      return {
        content,
        classes: "tooltip-menu",
        container: ".home",
        // show: true,
        arrowSelector: ".nav-link",
      };
    },
    tooltipProfile() {
      const content = `<div class="name truncate">
              ${this.tokenUser ? this.tokenUser.name : ""}
            </div>
            <div class="company truncate">${this.empresa.nombre}</div>`;
      return {
        content,
        container: ".home",
        classes: "tooltip-profile",
      };
    },
    getImgCompany(id) {
      if (id) {
        const imageCompany = this.$fire.getImgCompany(id);
        imageCompany
          .then((result) => {
            this.imageCompany = result;
          })
          .catch(() => {
            this.imageCompany = null;
          });
      }
    },
  },
  mounted() {
    this.constuyeMenu();
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.sidebar .menu-bar .a.router-link-active {
  background-color: var(--primary-color);
  color: #fff;
}

/* ===== Sidebar ===== */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 250px;
  background: var(--sidebar-color);
  transition: var(--tran-05);
  z-index: 100;
  box-shadow: 0 -10px 20px -5px rgba(115, 115, 115, 0.55),
    0 10px 20px -5px rgba(115, 115, 115, 0.55),
    10px 0 20px -5px rgba(115, 115, 115, 0.55);
}

.sidebar.close {
  width: 60px;
}

/* ================== */
.sidebar li {
  position: relative;
  height: 32px;
  list-style: none;
  display: flex;
  align-items: center;
  margin-top: 3px;
}

.sidebar ul div li:last-child {
  margin-bottom: 7px;
}

.sidebar .icon {
  min-width: 41px; // 38px con scroll
  border-radius: 6px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.sidebar .text,
.sidebar .icon {
  color: var(--text-color);
  transition: var(--tran-03);
}

.sidebar .title,
.sidebar .separator {
  transition: var(--tran-03);
}

.sidebar .text {
  font-size: 17px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 1;
}

.sidebar.close .text {
  opacity: 0;
}

.sidebar .menu-label {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.sidebar .menu-label .title {
  font-size: 15px;
  white-space: nowrap;
  color: var(--primary-color);
  padding: 5px;
  margin-bottom: 0 !important;
  border-radius: 5px;
  opacity: 1;
}

.sidebar.close .menu-label .title {
  opacity: 0;
}

.sidebar.close .menu-label::before {
  content: "";
  display: block;
  position: relative;
  min-width: 50px;
  border-top: 2px solid var(--primary-color);
  opacity: 0.5;
}

/* =========================== */

.sidebar header {
  position: relative;
  padding: 6px;
  // margin-bottom: 10px;
}

.sidebar header .logo {
  background-color: #fff;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
}

.sidebar header .logo-text {
  display: flex;
  flex-direction: column;
}
header .image-text .name {
  margin-top: 2px;
  font-size: 18px;
  font-weight: 600;
}

header .image-text .profession {
  font-size: 16px;
  margin-top: -2px;
  display: block;
}

.sidebar header .image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 86px;
}

.sidebar header .image .logo-text {
  width: 170px;
}

.sidebar header .image .logo-icon {
  width: 28px;
}

.sidebar header .toggle {
  position: absolute;
  top: 43%;
  right: -19px;
  transform: translateY(-50%) rotate(180deg);
  height: 25px;
  width: 25px;
  background-color: var(--primary-color);
  color: var(--primary-color-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  transition: var(--tran-05);
}

.sidebar.close .toggle {
  transform: translateY(-50%) rotate(0deg);
}

/* =========== Profile ============= */

.sidebar div.profile {
  height: 60px;
  width: 220px;
  margin-top: 12px;
  overflow: hidden;
}
.sidebar.close div.profile {
  width: 60px;
}

.sidebar div.profile-details {
  display: flex;
  flex-wrap: nowrap;
}
.sidebar div.profile-details img {
  cursor: pointer;
  height: 48px;
  width: 48px;
  object-fit: cover;
  border-radius: 6px;
}

.sidebar div.profile .name,
.sidebar div.profile .company {
  padding: 0 10px 0 5px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  text-decoration: none;
  cursor: pointer;
}
.sidebar div.profile .company {
  font-size: 14px;
  font-weight: 400;
}

.sidebar div.profile .name:hover {
  background-color: var(--primary-color);
}

.sidebar div.profile .company:hover {
  background-color: var(--primary-color);
}

.sidebar div.profile .name_company {
  transition: var(--tran-03);
  width: 165px;
  opacity: 1;
}

.sidebar.close div.profile .name_company {
  opacity: 0;
}

/* =========================== */

.sidebar li .a {
  list-style: none;
  background-color: transparent;
  display: flex;
  text-align: center;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  text-decoration: none;
  transition: var(--tran-03);
}

.sidebar li .a:hover {
  background-color: var(--primary-color);
}
.sidebar li .a:hover .icon,
.sidebar li .a:hover .text {
  color: var(--sidebar-color);
}

.sidebar .content-menu {
  height: 100%;
  padding: 6px 10px;
}

.sidebar .menu-bar {
  height: calc(100% - 155px - 55px); // Total - header - footer
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: visible;
  overflow-y: auto;
}

.sidebar.close .menu-bar {
  height: calc(100% - 130px - 55px); // Total - header - footer
}

.sidebar .bottom-content {
  background-color: var(--sidebar-color);
  margin-top: 3px;
  margin: 0 6px;
  border-top: 2px solid #fff;
  position: fixed;
  height: 48px;
  width: 238px;
  left: 0;
  bottom: 4px;
  padding: 4px;
  transition: all 0.5s ease;
  overflow: hidden;
}

.sidebar.close .bottom-content {
  width: 48px;
}

.sidebar .bottom-content li {
  margin-top: 2px;
}

.home {
  position: absolute;
  top: 0;
  top: 0;
  left: 250px;
  height: 100vh;
  width: calc(100% - 250px);
  background-color: var(--body-color);
  transition: var(--tran-05);
}
.home .text {
  font-size: 30px;
  font-weight: 500;
  color: var(--text-color);
  padding: 12px 60px;
}

/* Rounded border */
hr.rounded {
  width: 60px;
  border-top: 3px solid var(--primary-color);
  border-radius: 5px;
}

/* ========= ScrollBar Custom ========= */

.menu-bar::-webkit-scrollbar {
  display: none;
  width: var(--sb-size);
  margin-top: 10px;
  margin-bottom: 10px;
  opacity: 0; /* Inicialmente oculto */
  transition: opacity 0.3s ease; /* Transición suave para mostrar/ocultar */
}

.menu-bar:hover::-webkit-scrollbar {
  opacity: 1; /* Mostrar el scroll cuando se interactúa con el contenedor */
}

.menu-bar::-webkit-scrollbar-track {
  background: var(--sb-track-color);
  border-radius: 11px;
}

.menu-bar::-webkit-scrollbar-thumb {
  background: var(--sb-thumb-color);
  border-radius: 11px;
}
</style>

<style lang="scss">
/* ========= tooltip-menu ========= */

.tooltip-menu {
  font-size: 15px;
  z-index: 60;
}

.tooltip-profile {
  font-size: 15px;
  z-index: 60;
  margin-top: 30px !important;
  margin-left: -45px !important;
}

.tooltip-menu .tooltip-arrow {
  display: none;
}

.home.open > .tooltip-menu {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

.home.open > .tooltip-profile {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

@media (max-width: 420px) {
  .tooltip-menu,
  .tooltip-profile {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/Sidebar.vue